"use strict";

define('components/progress_modal',[], function() {
    
    var progressModalComponent = {
        init: function(container) {
        },

        createUploadProgressModal: function(headerText) {
            var progressBar = $('<div class="progress-bar progress-bar-striped"></div>')
                                .css({
                                    'width': '0%'
                                })
                                .attr({
                                    'role': 'progressbar',
                                    'aria-valuenow': '0',
                                    'aria-valuemin': '0',
                                    'aria-valuemax': '100',
                                });
            progressBar.append($('<div class="upload-status-message">0%</div>'));
            return $('<div class="modal fade in" role="dialog"></div>')
                        .append($('<div class="modal-dialog"></div>')
                            .append($('<div class="modal-content"></div>')
                                .append($('<div class="modal-header"></div>')
                                    .append($('<h4 class="modal-title"></h4>').text(headerText)))
                                .append($('<div class="modal-body"></div>')
                                    .append($('<div class="progress"></div>')
                                        .append(progressBar)))));
        },

        createUploadProgressXhr: function(modalNode) {
            var progressBar = modalNode.find('.progress-bar');
            var xhr = $.ajaxSettings.xhr();
            xhr.upload.onprogress = function(e) {
                var pc = Math.round(e.loaded / e.total * 100);
                progressBar.width(pc + "%");
                if (pc >= 100) {
                    modalNode.find(".upload-status-message").text("Processing...");
                } else {
                    modalNode.find(".upload-status-message").text(pc+"%");
                }
            };
            return xhr;
        }
    };

    return progressModalComponent;
});


